export const iconFontAwesomeHandsHandshake = (
	<i className="fa-solid fa-handshake"></i>
);
